export const LANDING_STATS = [
  {
    title: 'Weekly Views',
    value: '5000+',
  },
  {
    title: 'Leads a Year',
    value: '100+',
  },
  {
    title: 'Lead to Sale Ratio',
    value: '2%',
  },
  {
    title: 'Better Performance',
    value: '4x',
  },
  {
    title: 'Hours Saved Monthly',
    value: '65hrs',
  },
];
